import { useEffect } from 'react';

import { usePageSpaceKey } from '@confluence/page-context';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { useExperimentalPromotedSpacesQuery } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalPromotedSpacesQuery.ts';
import type {
	SpaceOperationsQueryType,
	SpaceOperationsQueryVariables,
} from '@confluence/entity-operations/entry-points/SpaceOperationsQuery.ts';
import { SpaceOperationsQuery } from '@confluence/entity-operations/entry-points/SpaceOperationsQuery.graphql.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
// TODO CCT-176: try removing these queries when fabric beta FF is enabled
export const CreateContentDataPreloader = () => {
	const [currentSpaceKey] = usePageSpaceKey();

	const { data: promotedSpaceData, error: promotedSpaceError } = useExperimentalPromotedSpacesQuery(
		{
			variables: {
				promotedSpaceKey: currentSpaceKey,
				promotedSpacesLimit: 1,
				otherSpacesLimit: 1,
			},
		},
	);

	const spaceKey = promotedSpaceData?.experimentalPromotedSpaces?.nodes?.[0]?.id || '';
	const { error: operationsError } = useQueryInterop<
		SpaceOperationsQueryType,
		SpaceOperationsQueryVariables
	>(SpaceOperationsQuery, {
		variables: {
			spaceKey,
		},
		skip: !spaceKey,
	});

	useEffect(() => {
		// error will be reported if the user actually triggers a create via the handler
		markErrorAsHandled(promotedSpaceError);
		markErrorAsHandled(operationsError);
	}, [promotedSpaceError, operationsError]);

	return null;
};
